<template>
  <div class="job-photo-list">
    <div
      class="job-photo-list__main"
      :style="{
        backgroundImage: 'url(' + toolPhoto + ')',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }"
    ></div>
    <div class="job-photo-list__others">
      <template
        v-if="job.gallery.length > 0"
        v-for="(image, index) in job.gallery"
      >
        <div :key="index" class="photo" @mouseover="setToolPhoto(image)">
          <b-img-lazy :src="image.thumb_url" fluid></b-img-lazy>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Current Job/Tool photo list
 * ==================================================================================
 **/

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      job: state => state.job.jobDetails
    }),
    toolPhoto() {
      if (
        !this.job ||
        !this.job.gallery ||
        (this.job.gallery && this.job.gallery.length === 0)
      )
        return require('@/assets/images/img-placeholder.svg')

      return (
        this.activePhoto ||
        this.job.gallery[0].permanent_url ||
        this.job.gallery[0].url
      )
    }
  },
  data: function() {
    return {
      activePhoto: null
    }
  },
  methods: {
    setToolPhoto(image) {
      this.activePhoto = image.permanent_url || image.url
    }
  }
}
</script>
<style scoped lang="scss">
.job-photo-list {
  display: flex;
  flex-direction: row;
  margin-top: 10px;

  img {
    width: auto;
    // height: 100%;
  }

  $height: 505px;
  &__main {
    width: 85%;
    height: $height;
    margin-right: 3.25%;
    margin-top: 5px;
    border-radius: 10px;
    background: white;
    overflow: hidden;
  }

  $spacing: 25px;
  $border: 5px;
  &__others {
    width: 16.75%;
    flex-grow: 1;
    height: $height + ($border * 2);
    padding: $border;
    overflow: scroll;

    .photo {
      display: flex;
      align-items: center;
      width: 100%;
      height: ($height - ($spacing * 3)) / 4;
      margin-bottom: $spacing;
      border-radius: 3px;
      background: white;
      overflow: hidden;
      cursor: pointer;
      transition: box-shadow var(--anim-trans);
      box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0);
    }

    .photo:hover {
      box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.05);
    }

    .photo:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 568px) {
  .job-photo-list {
    flex-direction: column;

    &__main {
      height: 300px;
      width: 100%;
      margin-right: 0;
      margin-bottom: 15px;
    }

    &__others {
      display: block;
      height: 80px;
      width: 100%;
      padding: 0;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;

      .photo {
        position: relative;
        display: inline-block;
        vertical-align: top;
        height: 80px;
        width: 24.5%;
        margin-right: 1%;
        text-align: center;

        img {
          height: 100%;
          max-height: 80px;
        }
      }

      .photo:hover {
        box-shadow: none;
      }
    }
  }
}
</style>
